var _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyPageIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.0789V34.9211C2.53954e-05 35.8265 0.234717 36.7159 0.680495 37.4999C1.12627 38.2841 1.76744 38.9351 2.53954 39.3878L19.4604 49.309C20.2326 49.7617 21.1085 50 22 50C22.8916 50 23.7674 49.7617 24.5395 49.309L41.4605 39.3878C42.2326 38.9351 42.8737 38.2841 43.3195 37.4999C43.7654 36.7159 44 35.8265 44 34.9211V15.0789C44 14.1735 43.7654 13.2841 43.3195 12.5001C42.8737 11.7159 42.2326 11.0648 41.4605 10.6122L24.5395 0.691018C23.7674 0.238325 22.8916 0 22 0C21.1085 0 20.2326 0.238325 19.4604 0.691018L2.53954 10.6122C1.76744 11.0648 1.12627 11.7159 0.680495 12.5001C0.234717 13.2841 2.53954e-05 14.1735 0 15.0789Z",
    fill: "#0E2659"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3178_212443",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 50
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.0789V34.9211C2.53954e-05 35.8265 0.234717 36.7159 0.680495 37.4999C1.12627 38.2841 1.76744 38.9351 2.53954 39.3878L19.4604 49.309C20.2326 49.7617 21.1085 50 22 50C22.8916 50 23.7674 49.7617 24.5395 49.309L41.4605 39.3878C42.2326 38.9351 42.8737 38.2841 43.3195 37.4999C43.7654 36.7159 44 35.8265 44 34.9211V15.0789C44 14.1735 43.7654 13.2841 43.3195 12.5001C42.8737 11.7159 42.2326 11.0648 41.4605 10.6122L24.5395 0.691018C23.7674 0.238325 22.8916 0 22 0C21.1085 0 20.2326 0.238325 19.4604 0.691018L2.53954 10.6122C1.76744 11.0648 1.12627 11.7159 0.680495 12.5001C0.234717 13.2841 2.53954e-05 14.1735 0 15.0789Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3178_212443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9 7.5H54",
    stroke: "#143478",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 13.5H54",
    stroke: "#143478",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 19.5H54",
    stroke: "#143478",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 25.5H54",
    stroke: "#143478",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 31.5H54",
    stroke: "#143478",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 37.5H54",
    stroke: "#143478",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 43.5H54",
    stroke: "#143478",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.5 34L14 19L30 31.5L57.5 13",
    stroke: "#4987FF",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 20,
    r: 4.5,
    fill: "#0E2659",
    stroke: "#4987FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 4.5,
    fill: "#0E2659",
    stroke: "#4987FF",
    strokeWidth: 3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9845 36.7586L1.98445 36.7585C1.66769 36.2014 1.50002 35.5676 1.5 34.9211V15.0789C1.5 15.0789 1.5 15.0789 1.5 15.0789C1.50003 14.4324 1.6677 13.7986 1.98445 13.2415L1.9845 13.2414C2.3012 12.6843 2.75506 12.2246 3.29822 11.9061L3.29823 11.9061L20.2191 1.98503C20.2191 1.98502 20.2191 1.98501 20.2191 1.985C20.7622 1.66665 21.3763 1.5 22 1.5C22.6238 1.5 23.2378 1.66664 23.7808 1.985C23.7808 1.98501 23.7809 1.98502 23.7809 1.98502L40.7018 11.9061L40.7018 11.9062C41.245 12.2246 41.6988 12.6843 42.0156 13.2414L42.0156 13.2415C42.3324 13.7986 42.5 14.4324 42.5 15.0789V34.9211C42.5 35.5676 42.3324 36.2014 42.0156 36.7585L42.0156 36.7586C41.6988 37.3157 41.245 37.7754 40.7018 38.0939L23.7808 48.015C23.2378 48.3334 22.6238 48.5 22 48.5C21.3762 48.5 20.7621 48.3334 20.2191 48.015L3.29827 38.0939C2.75504 37.7754 2.30118 37.3156 1.9845 36.7586Z",
    stroke: "#1F408C",
    strokeWidth: 3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyPageIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty-page-icon.db35d6391c5c91c3eeb4aba4dfc637b7.svg";